import { useState } from 'react';
import { Clock } from 'lucide-react';
import { takeSessionExpiredFlag } from '@/lib/session';

/*
  Why somebody is suddenly looking at a login screen.

  Being returned to sign-in with no explanation reads as a fault — people retry
  the same password, decide the system has lost their account, and ring the
  office. One sentence turns it into something ordinary that they know how to
  deal with.

  The flag is read once, on mount, and cleared, so it belongs to this arrival at
  the login screen and does not reappear the next time somebody signs out on
  purpose.
*/
export function SessionExpiredNotice() {
  const [expired] = useState(takeSessionExpiredFlag);
  if (!expired) return null;

  return (
    <div
      role="status"
      className="mb-3 flex items-start gap-2 rounded-lg border border-info/30 bg-info/[0.07] px-3 py-2.5"
    >
      <Clock size={14} className="mt-[1px] flex-shrink-0 text-[hsl(var(--record-ink-info))]" />
      <p className="text-[11.5px] leading-relaxed text-[hsl(var(--record-ink-info))]">
        <strong className="font-bold">You were signed out.</strong> Your session had been open too
        long. Sign in again — nothing has been lost.
      </p>
    </div>
  );
}
